import { ETAB_ROUTES } from "@etab/config";
import { LoadingManager } from "@core/managers/loading.manager";
import { ACTION_RECRUITMENTS_SET_SELECTED, ACTION_RECRUITMENT_GET } from "@etab/stores/types";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { useRecruitmentStore } from "@etab/stores/recruitment";
import { useRecruitmentsStore } from "@etab/stores/recruitments";
import RecruitmentRoot from "./Recruitment.root.vue";
import getPermanentPages from "./permanent";
import getTemporaryPages from "./temporary";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.root.name,
      component: RecruitmentRoot,
      async beforeEnter(to, from, next) {
        const recruitmentStore = useRecruitmentStore();
        const recruitmentsStore = useRecruitmentsStore();
        try {
          LoadingManager.show();
          const demandId = to.params.demandId;
          const demandType = to.params.demandType;
          await recruitmentStore[ACTION_RECRUITMENT_GET]({ demandId, demandType });
          recruitmentsStore[ACTION_RECRUITMENTS_SET_SELECTED](demandId);
          next();
          LoadingManager.hide();
        } catch (error) {
          const status = error?.response?.status;
          switch (status) {
            case 403:
            case 404: {
              NotificationsManager.error({ message: "ERRORS.@DEMAND_404" });
              break;
            }
            default: {
              NotificationsManager.error();
              break;
            }
          }
          next({ name: ETAB_ROUTES.dashboard.tabs.root.name });
          LoadingManager.hide();
          throw error;
        }
      },
      children: [
        ...getPermanentPages(), //
        ...getTemporaryPages(),
      ],
    },
  ];
}
